import { signal } from '@angular/core';

/** The part of a horizontal scroller {@link TimelineZoom.follow} needs. */
export interface Scrollable { scrollWidth: number; clientWidth: number; scrollLeft: number; }

/**
 * Zoom for the dock's tracks. The tracks are laid out `level × 100%` wide inside
 * a horizontal scroller; the labels stay put. {@link follow} keeps the playhead
 * on screen while playing without fighting a person who is scrolling around.
 */
export class TimelineZoom {
  static readonly LEVELS = [1, 2, 4, 8, 16];
  readonly level = signal(1);

  in(): void { this.step(1); }
  out(): void { this.step(-1); }
  fit(): void { this.level.set(1); }

  /** Scroll so the playhead sits in the middle once it leaves the central band. */
  follow(scroller: Scrollable | null | undefined, cursorPct: number): void {
    if (!scroller || this.level() === 1) return;
    const x = (cursorPct / 100) * scroller.scrollWidth;
    const left = scroller.scrollLeft;
    const w = scroller.clientWidth;
    if (x < left + w * 0.1 || x > left + w * 0.9) scroller.scrollLeft = Math.max(0, x - w / 2);
  }

  private step(dir: 1 | -1): void {
    const levels = TimelineZoom.LEVELS;
    const i = Math.max(0, Math.min(levels.length - 1, levels.indexOf(this.level()) + dir));
    this.level.set(levels[i]);
  }
}
